import { useEffect, useState } from 'react'

import { DemographicFunctions } from './DemographicFunctions'

import { OptionsField } from '@/types/forms/'

export const useResidenceData = (
    watchCountryResidence: string,
    watchDepartmentResidence: string
) => {
    const {
        fetchCountries,
        fetchDepartments,
        fetchCities,
        fetchLocalidad,
        fetchOptionsTimeResidence
    } = DemographicFunctions()

    const [countries, setCountries] = useState<OptionsField[]>([])
    const [idCityResidence, setIdCityResidence] = useState<OptionsField[]>([])
    const [residenceDepartments, setResidenceDepartments] = useState<
        OptionsField[]
    >([])
    const [optionsLocality, setOptionsLocality] = useState<OptionsField[]>([])
    const [TimeResidence, setTimeResidence] = useState<OptionsField[]>([])

    //* Country
    useEffect(() => {
        let mounted = true
        const fetchResidenceCountries = async (): Promise<void> => {
            const response = await fetchCountries(mounted)

            if (mounted && response) {
                setCountries(response)
            }
        }

        fetchResidenceCountries()

        return (): void => {
            mounted = false
        }
    }, [])

    //* Department - CON RETRY
    useEffect(() => {
        let mounted = true
        const maxRetries = 3

        // Si no hay país seleccionado, limpiar departamentos
        if (!watchCountryResidence || watchCountryResidence === '') {
            if (mounted) {
                setResidenceDepartments([])
            }

            return
        }

        const fetchWithRetry = async (attempt = 0): Promise<void> => {
            try {
                const response = await fetchDepartments(
                    mounted,
                    watchCountryResidence
                )

                if (mounted) {
                    if (response && response.length > 0) {
                        setResidenceDepartments(response)

                        return
                    }

                    if (attempt < maxRetries) {
                        setTimeout(
                            () => {
                                if (mounted) {
                                    fetchWithRetry(attempt + 1)
                                }
                            },
                            1000 * (attempt + 1)
                        )
                    } else {
                        setResidenceDepartments([])
                    }
                }
            } catch (error) {
                if (mounted && attempt < maxRetries) {
                    setTimeout(
                        () => {
                            if (mounted) {
                                fetchWithRetry(attempt + 1)
                            }
                        },
                        1000 * (attempt + 1)
                    )
                } else if (mounted) {
                    setResidenceDepartments([])
                }
            }
        }

        fetchWithRetry()

        return () => {
            mounted = false
        }
    }, [watchCountryResidence])

    //* City
    useEffect(() => {
        let mounted = true

        // Si no hay país o departamento seleccionado, limpiar ciudades
        if (
            !watchCountryResidence ||
            watchCountryResidence === '' ||
            !watchDepartmentResidence ||
            watchDepartmentResidence === ''
        ) {
            if (mounted) {
                setIdCityResidence([])
            }

            return
        }

        const fetchResidenceCities = async (): Promise<void> => {
            const response = await fetchCities(
                mounted,
                watchCountryResidence,
                watchDepartmentResidence
            )

            if (mounted && response) {
                setIdCityResidence(response)
            }
        }

        fetchResidenceCities()

        return (): void => {
            mounted = false
        }
    }, [watchCountryResidence, watchDepartmentResidence])

    //* Localidad
    useEffect(() => {
        let mounted = true
        const fetchLocalidadEffect = async (): Promise<void> => {
            const response = await fetchLocalidad(mounted)

            if (mounted && response) {
                setOptionsLocality(response)
            }
        }

        fetchLocalidadEffect()

        return (): void => {
            mounted = false
        }
    }, [])

    //* Time Residence
    useEffect(() => {
        let mounted = true
        const fetchTimeResidence = async (): Promise<void> => {
            const response = await fetchOptionsTimeResidence(mounted)

            if (mounted && response) {
                setTimeResidence(response)
            }
        }

        fetchTimeResidence()

        return (): void => {
            mounted = false
        }
    }, [])

    return {
        countries,
        idCityResidence,
        residenceDepartments,
        optionsLocality,
        TimeResidence
    }
}
